import * as React from 'react'

import { Box, Table } from '@factorialco/deprecated-design-system'
import { TimesheetPageShiftFragment } from 'generated/resources/graphql'
import type moment from 'moment'

import { observer } from 'mobx-react'

import type Store from 'modules/attendance/components/ClockIn/Store'

import OptionsButton from './OptionsButton'

interface Props {
  date: moment.Moment
  store: Store
  shifts: TimesheetPageShiftFragment[]
}

const OptionsColumn = ({ date, store, shifts }: Props) => {
  return (
    <Table.Cell verticalAlign="middle">
      <Box padding="s6" alignItems="flexEnd">
        <OptionsButton date={date} store={store} shifts={shifts} />
      </Box>
    </Table.Cell>
  )
}

export default observer(OptionsColumn)
